import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";

const config = {
  apiKey: "AIzaSyBgSbI60foc67qNb8pCBNsJMyB2Jr4Voy8",
  authDomain: "oauth.mybillees.com",
  databaseURL: "https://billees-shop.firebaseio.com",
  projectId: "billees-shop",
  storageBucket: "billees-shop.appspot.com",
  messagingSenderId: "51051968134",
  appId: "1:51051968134:web:6892e285e611172a178307",
  measurementId: "G-B8HWD9GQML",
};
firebase.initializeApp(config);
firebase.analytics();

export default firebase;
